class HeaderSearch {

  constructor(element) {
    this.element = element
    this.searchButton = this.element.querySelector('.header__search-btn')
    this.searchInput = this.element.querySelector('input')

    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleEscapeClick = this.handleEscapeClick.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)
  }

  handleSearchClick(event) {
    event.preventDefault()

    if (this.element.classList.contains('show-search')) {
      this.element.classList.remove('show-search')
      return
    }

    this.element.classList.add('show-search')
    this.searchInput.focus()
  }

  handleEscapeClick(event) {
    if (event.key == 'Escape') {
      this.element.classList.remove('show-search')
    }
  }

  handleBodyClick(event) {

    if (event.target.closest('.nav-secondary')) {
      return;
    }

    this.element.classList.remove('show-search')
  }

  init() {
    this.searchButton.addEventListener('click', this.handleSearchClick)
    this.element.addEventListener('keyup', this.handleEscapeClick)
    document.body.addEventListener('click', this.handleBodyClick)
  }
}

export default HeaderSearch;
